// import hotjarPlugin from './analytics-plugin-hotjar'
import segmentAnalyticsPLugin from '@analytics/segment'
import Analytics, { AnalyticsPlugin } from 'analytics'

const getPlugins = () => {
  const pluginList: AnalyticsPlugin[] = []
  if (process.env.NEXT_PUBLIC_SEGMENT_TRACKING_ID) {
    pluginList.push(segmentAnalyticsPLugin({ writeKey: process.env.NEXT_PUBLIC_SEGMENT_TRACKING_ID }))
  }
  return pluginList
}

const analytics = Analytics({
  app: 'sho-app',
  plugins: getPlugins(),
})

export { analytics }
